/** What the portal monitor tells its subscribers. */
export enum PortalEvent {
    /** The probes failed often enough in a row to give up on the cloud. */
    Unavailable = 'unavailable',
    /** A success after Unavailable. */
    Recovered = 'recovered',
    /**
     * A success after a failure started the probes, before or after Unavailable. A read or a
     * write made since that failure may have failed, and the stream may have stayed open over it.
     */
    Answered = 'answered',
}
